import { render, staticRenderFns } from "./ImageGallery.vue?vue&type=template&id=4a68d3df&"
import script from "./ImageGallery.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImageGallery.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports